import ParentCategorySimpleView from './ParentCategorySimpleView'

export default ParentCategorySimpleView
